import React, { useEffect, useState } from "react";
import PopupLoader from "../../views/popups/PopupLoader";

const FReport = (props) => {
    const [report, setReport] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Replace with your actual API endpoint
        fetch("/api/report")
            .then((res) => {
                if (!res.ok) throw new Error("Failed to fetch report");
                return res.json();
            })
            .then((data) => {
                setReport(data);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, []);

    if (loading) return <div>Loading report...</div>;
    if (error) return <div>Error: {error}</div>;
    if (!report) return <div>No report data found.</div>;

    return (
        <PopupLoader
            size="lg"
            className="modal-lg"
            title="Create New Schedule"
            content={
                <div>
                    <h2>Report</h2>

                </div>
            }
            onShow={true}
            open={props.set}
            onClose={props.set}
        />
    );
};

export default FReport;
